import { Document, Folder, Identifiable } from "@planzone/dto";

function separateDocumentAndFolder(
  a: Identifiable<Folder> | Identifiable<Document>,
  b: Identifiable<Folder> | Identifiable<Document>,
) {
  return a.type === "folder" && b.type === "document"
    ? -1
    : a.type === "document" && b.type === "folder"
      ? 1
      : 0;
}

export { separateDocumentAndFolder };
